import { render, staticRenderFns } from "./ng.vue?vue&type=template&id=a51e2b9c"
import script from "./ng.vue?vue&type=script&lang=js"
export * from "./ng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports